import Image from "next/image";
import Gutter from "ui-kit/Gutter";
import { Typography } from "ui-kit/Typography";
import styles from "./AddonBox.module.css";
import Switch from "ui-kit/Switch/Switch";
import { ReactNode, useState } from "react";
import { useWebTranslation } from "translations";
import Overlay from "../Overlay";
import { useLottieAnimation } from "hooks/useLottieAnimation";
import Stars from "../../../../assets/animations/stars.json";

type Props = {
  title: string;
  summary: string;
  switchDescription?: string;
  onChange: VoidFunction;
  details?: ReactNode;
  active: boolean;
  image: string;
  readmore?: ReactNode;
};

export const AddonBox = ({
  title,
  summary,
  onChange,
  active,
  switchDescription,
  image,
  details,
  readmore,
}: Props) => {
  const { t } = useWebTranslation();
  const [showOverlay, setShowOverlay] = useState(false);

  const ref = useLottieAnimation({ animation: Stars, loop: false });

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.text}>
          <Typography variant="body2">
            <strong>{title}</strong>
          </Typography>
          <Gutter size={0.5} />
          <Typography variant="body3" color="grey500">
            {summary}
          </Typography>
          {readmore && (
            <button
              className={styles.readMore}
              style={{ display: "block" }}
              onClick={() => setShowOverlay(true)}
            >
              <Typography variant="body3" color="blue300">
                <strong>{t("global.read_more")}</strong>
              </Typography>
            </button>
          )}
        </div>
        <div className={styles.image}>
          <Image alt="" width={100} height={100} src={image} />
        </div>
      </div>
      <div className={styles.bottomBar}>
        <Typography variant="body3" color="grey500">
          <strong>{switchDescription}</strong>
        </Typography>
        <button onClick={onChange} className={styles.switch}>
          <Switch active={active} activeColor="blue300" />
          {active ? <div ref={ref} className={styles.sparkles} /> : null}
        </button>
      </div>
      {active && details && <div style={{ padding: 20 }}>{details}</div>}
      {showOverlay && (
        <Overlay
          display={{ title: title, content: readmore }}
          onRemove={() => setShowOverlay(false)}
        />
      )}
    </div>
  );
};
